/* eslint-disable no-extend-native */

Object.defineProperty(String.prototype, "hyphenate", {
    value: function() {
        return this.toLowerCase().replace(/[ ]/g, "-")
    },
    enumerable: false,
})
